import * as R from 'ramda';

export default function AssetsByTypeController(
  $scope,
  $q,
  $rootScope,
  alerts,
  confirmDialog,
  userService,
  ssDialogService,
  editAssetDialog,
  loaderService,
  assetSharedModelService,
  assetDataService,
  praDataService,
  bulkDeleteAssetsDialog,
  bulkChangeAssetTypesDialog,
  syncAssetTypeDialog,
) {
  const vm = this;

  vm.hasData = false;
  vm.canExpand = true;
  vm.isExpanded = false;

  vm.showSyncWithNetComply =
    vm.assetType.canSyncWithNetComply && (vm.hasNetComply || (vm.hasEndpointManagement && vm.rmmReportingSource === 2));

  vm.handleExpandClick = _handleExpandClick;
  vm.handleAddAssetClick = _handleAddAssetClick;
  vm.handleSelectAllChange = _handleSelectAllChange;
  vm.handleBulkDeleteAssets = _handleBulkDeleteAssets;
  vm.handleSyncClick = _handleSyncClick;
  vm.handleSyncWithEndpointManagement = _handleSyncWithEndpointManagement;
  vm.handleBulkChangeAssetTypes = _handleBulkChangeAssetTypes;
  vm.isAssetTypeInSync = _isAssetTypeInSync;

  _activate();

  function _activate() {
    if (vm.assignAsset === true) {
      vm.tooltipAppendToSelector = '#assignAssetDialog';
    }
    $scope.$on('refreshAssessmentAssets', (event, opt) => {
      if (opt.assetType.customerAssetTypeId === vm.assetType.customerAssetTypeId) {
        loaderService.showViewLoader = true;
        _getAssetsByAssetType();
      }
    });

    $scope.$on('refreshAssets', (event, opt) => {
      if (opt.assetType.customerAssetTypeId === vm.assetType.customerAssetTypeId) {
        loaderService.showViewLoader = true;
        _getAssetTypeWithInstances();
      }
    });

    $scope.$on('refreshAssignAssetCount', (event, opt) => {
      if (opt.assetType.customerAssetTypeId === vm.assetType.customerAssetTypeId) {
        updateAttachedCount();
        vm.selectAll = setSelectAllFlag();
      }
    });

    _initPermissions();
    _initTooltips();
    _initCriticality();
    _initRiskTypeSeverity();
    _initRiskTypeProbability();
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _initTooltips() {
    vm.assetType.assetDataTypeTooltip = 'This is ';
    switch (vm.assetType.assetDataTypeId) {
      case 1:
        vm.assetType.assetDataTypeTooltip += ' a Physical Asset.';
        break;
      case 2:
        vm.assetType.assetDataTypeTooltip += ' an Electronic Asset.';
        break;
      case 3:
        vm.assetType.assetDataTypeTooltip += ' both a Physical and Electronic Asset.';
        break;
      default:
        vm.assetType.assetDataTypeTooltip = null;
    }
  }

  function _initCriticality() {
    if (vm.assetType.assetCriticalityId) {
      const classMappings = {
        1: 'status-tier-bar--terrible',
        2: 'status-tier-bar--bad',
        3: 'status-tier-bar--caution',
        4: 'status-tier-bar--good',
        5: 'status-tier-bar--great',
      };
      vm.assetType.criticalityCssClass = classMappings[vm.assetType.assetCriticalityId];
      vm.assetType.assetCriticality = assetSharedModelService.AssetCriticalities.find(
        assetCriticality => assetCriticality.assetCriticalityId === vm.assetType.assetCriticalityId,
      );
    }
  }

  function _initRiskTypeProbability() {
    if (vm.assetType.customerAssetCustomerRisks) {
      vm.assetType.customerAssetCustomerRisks = assetSharedModelService.addProbabilityCssClassesToRiskTypes(
        vm.assetType.customerAssetCustomerRisks,
      );
    }
  }

  function _initRiskTypeSeverity() {
    if (vm.assetType.customerAssetCustomerRisks) {
      vm.assetType.customerAssetCustomerRisks = assetSharedModelService.addSeverityDescriptionsToRisks(
        vm.assetType.customerAssetCustomerRisks,
      );
    }
  }

  function _handleExpandClick() {
    if (!vm.isExpanded) {
      if (vm.isPraProcessMain === true || vm.isEditProcessDialog === true) {
        if (!vm.hasData) {
          praDataService
            .getAssetsByAssetTypeId(vm.process.assessmentProcessId, vm.assetType.customerAssetTypeId)
            .then(getAssetTypeResponse => {
              vm.assetType.customerAssets = getAssetTypeResponse.data.result;
              vm.hasData = true;
            });
        }
      } else if (!vm.hasData) {
        vm.assetType.customerAssets = [];
        assetDataService.getAssetTypeWithInstances(vm.assetType.customerAssetTypeId).then(getAssetTypeResponse => {
          Object.assign(vm.assetType, getAssetTypeResponse.data);
          if (vm.assignAsset === true && vm.assetType.customerAssets && vm.assetType.customerAssets.length > 0) {
            transformAssetList();
            vm.selectAll = setSelectAllFlag();
          }
          vm.hasData = true;
        });
      }
    }
    vm.isExpanded = !vm.isExpanded;
  }

  function _getAssetTypeWithInstances() {
    assetDataService.getAssetTypeWithInstances(vm.assetType.customerAssetTypeId).then(getAssetTypeResponse => {
      Object.assign(vm.assetType, getAssetTypeResponse.data);
      _initCriticality();
      _initCriticalityForAssets(vm.assetType.customerAssets);
      if (vm.assignAsset === true && vm.assetType.customerAssets && vm.assetType.customerAssets.length > 0) {
        transformAssetList();
        vm.selectAll = setSelectAllFlag();
      }
      loaderService.showViewLoader = false;
    });
  }

  function _handleAddAssetClick($event) {
    loaderService.showViewLoader = true;
    const asset = { customerAssetId: 0 };
    ssDialogService.dialogs.assetAdmin.editAssetDialog = ssDialogService.alert(
      editAssetDialog.getOptions($event, {
        asset,
        assetCriticalities: assetSharedModelService.AssetCriticalities,
        assetDataTypes: assetSharedModelService.AssetDataTypes,
        assetDataUses: assetSharedModelService.AssetDataUses,
        assetTypes: assetSharedModelService.AssetTypes,
        preselectedAssetTypeId: vm.assetType.customerAssetTypeId,
      }),
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetDialog);
  }

  function _handleBulkChangeAssetTypes($event) {
    if (!vm.hasData) {
      loaderService.showViewLoader = true;
      assetDataService.getAssetTypeWithInstances(vm.assetType.customerAssetTypeId).then(getAssetTypeResponse => {
        Object.assign(vm.assetType, getAssetTypeResponse.data);
        vm.hasData = true;
        loaderService.showViewLoader = false;
        showBulkChangeAssetTypesDialog($event);
      });
    } else {
      showBulkChangeAssetTypesDialog($event);
    }
  }

  function showBulkChangeAssetTypesDialog($event) {

    let _bulkAssetType = { ...vm.assetType };
    let movaeableAssets = [];

    R.forEach(asset => {
      if ((asset.presetsNamePrefix !== '') && (asset.presetsNamePrefix !== null) && (asset.presetsNamePrefix !== undefined)) {
        movaeableAssets.push(asset);
      }
    }, _bulkAssetType.customerAssets);

    _bulkAssetType.customerAssets = movaeableAssets;

    let movaeableAssetTypes = [];

    R.forEach(assetType => {
      if ((assetType.isITAsset === vm.assetType.isITAsset) && (assetType.customerAssetTypeId !== vm.assetType.customerAssetTypeId)) {
        movaeableAssetTypes.push(assetType);
      }
    }, assetSharedModelService.AssetTypes);

    ssDialogService.dialogs.assetAdmin.bulkChangeAssetTypesDialog = ssDialogService.alert(
      bulkChangeAssetTypesDialog.getOptions($event, {
        customerId: vm.customerId,
        assetType: _bulkAssetType,
        assetTypes: movaeableAssetTypes,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.assetAdmin.bulkChangeAssetTypesDialog);
  }

  function _handleBulkDeleteAssets($event) {
    if (!vm.hasData) {
      loaderService.showViewLoader = true;
      assetDataService.getAssetTypeWithInstances(vm.assetType.customerAssetTypeId).then(getAssetTypeResponse => {
        Object.assign(vm.assetType, getAssetTypeResponse.data);
        vm.hasData = true;
        loaderService.showViewLoader = false;
        showBulkDeleteAssetsDialog($event);
      });
    } else {
      showBulkDeleteAssetsDialog($event);
    }
  }

  function _isAssetTypeInSync($event) {
    return !vm.assetType.isSynced;
  }

  function showBulkDeleteAssetsDialog($event) {
    ssDialogService.dialogs.assetAdmin.bulkDeleteAssetsDialog = ssDialogService.alert(
      bulkDeleteAssetsDialog.getOptions($event, {
        customerId: vm.customerId,
        assetType: vm.assetType,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.assetAdmin.bulkDeleteAssetsDialog);
  }

  function transformAssetList() {
    let assignedCount = 0;
    R.forEach(asset => {
      asset.isAssigned = false;
      let isAssigned = false;
      if (vm.assetType.assignedAssets && vm.assetType.assignedAssets.length > 0) {
        isAssigned = R.find(R.propEq('customerAssetId', asset.customerAssetId), vm.assetType.assignedAssets);
      }
      if (isAssigned) {
        asset.isAssigned = true;
        assignedCount += 1;
      }
    }, vm.assetType.customerAssets);
    vm.assetType.attached = assignedCount;
  }

  function setSelectAllFlag() {
    return vm.assetType.attached === vm.assetType.customerAssets.length;
  }

  function _handleSelectAllChange() {
    if (vm.assetType.customerAssets) {
      R.forEach(asset => {
        asset.isAssigned = vm.selectAll;
      }, vm.assetType.customerAssets);
      updateAttachedCount();
    }
  }

  function _getAssetsByAssetType() {
    const promises = [
      praDataService.getAssetsByAssetTypeId(vm.process.assessmentProcessId, vm.assetType.customerAssetTypeId),
    ];
    if (vm.isPraProcessMain === true || vm.isEditProcessDialog === true) {
      promises.push(praDataService.getProcessAssetsByType(vm.process.assessmentProcessId));
    }
    $q.all(promises).then(getAssetTypeResponse => {
      vm.assetType.customerAssets = getAssetTypeResponse[0].data.result;
      loaderService.showViewLoader = false;
      const assetTypes = getAssetTypeResponse[1].data.customerAssetTypes;
      const assetType = R.filter(R.propEq('customerAssetTypeId', vm.assetType.customerAssetTypeId), assetTypes);
      vm.assetType.assessmentCustomerAssetCount = assetType[0].assessmentCustomerAssetCount;
      vm.assetType.inherentRiskCalculated = assetType[0].inherentRiskCalculated;
      vm.assetType.residualRiskCalculated = assetType[0].residualRiskCalculated;
      vm.hasData = true;
    });
  }

  function updateAttachedCount() {
    let assignedCount = 0;
    R.forEach(asset => {
      if (asset.isAssigned === true) {
        assignedCount += 1;
      }
    }, vm.assetType.customerAssets);
    vm.assetType.attached = assignedCount;
  }

  function _handleSyncClick($event) {
    loaderService.showViewLoader = true;
    return assetDataService.getAssetTypeWithInstances(vm.assetType.customerAssetTypeId).then(getAssetTypeResponse => {
      vm.assetTypeOfSync = angular.copy(vm.assetType);
      Object.assign(vm.assetTypeOfSync, getAssetTypeResponse.data);
      loaderService.showViewLoader = false;
      _showSyncAssetTypeDialog($event);
    });
  }

  function _handleSyncWithEndpointManagement($event) {
    if (vm.hasEndpointManagement && vm.rmmReportingSource === 2) {
      _confirmSyncWithDatto($event);
    } else {
      _confirmSyncWithNetComply($event);
    }
  }

  function _confirmSyncWithDatto($event) {
    return assetDataService.getDattoAssetTypeCount(vm.assetType.customerAssetTypeId).then(response => {
      const count = response.data;

      if (count > 0) {
        ssDialogService.dialogs.assetAdmin.confirmSyncWithNetComplyDialog = ssDialogService.alert(
          confirmDialog.getOptions($event, {
            dialogTitle: 'Synchronize Asset Type with Endpoint Management?',
            warningMessage: `Synchronizing the "${vm.assetType.name}" Asset Type with Endpoint Management will delete all existing Asset Instances from Asset Administration, impacting your Information Security Risk Assessment.`,
            message: `Do you want to continue with syncing your ${count} ${vm.assetType.name}?`,
            handleYesClick: _performSyncWithDatto,
            handleNoClick: _closeConfirmSyncWithNetComplyDialog,
          }),
        );

        ssDialogService.show(ssDialogService.dialogs.assetAdmin.confirmSyncWithNetComplyDialog);
      } else {
        alerts.warning('All Endpoint Management Entities are already in the Asset List. Please delete them and try again.');
      }
    });
  }

  function _confirmSyncWithNetComply($event) {
    return assetDataService.getNetComplyAssetTypeCount(vm.assetType.customerAssetTypeId).then(response => {
      const count = response.data;

      if (count > 0) {
        ssDialogService.dialogs.assetAdmin.confirmSyncWithNetComplyDialog = ssDialogService.alert(
          confirmDialog.getOptions($event, {
            dialogTitle: 'Synchronize Asset Type with Endpoint Management?',
            warningMessage: `Synchronizing the "${vm.assetType.name}" Asset Type with Endpoint Management will delete all existing Asset Instances from Asset Administration, impacting your Information Security Risk Assessment.`,
            message: `Do you want to continue with syncing your ${count} ${vm.assetType.name}?`,
            handleYesClick: _performSyncWithNetComply,
            handleNoClick: _closeConfirmSyncWithNetComplyDialog,
          }),
        );

        ssDialogService.show(ssDialogService.dialogs.assetAdmin.confirmSyncWithNetComplyDialog);
      } else {
        alerts.warning('All Endpoint Management Entities are already in the Asset List. Please delete them and try again.');
      }
    });
  }

  function _performSyncWithDatto($event) {
    loaderService.showViewLoader = true;
    return assetDataService.synchronizeAssetTypesFromDatto(vm.assetType.customerAssetTypeId).then(response => {
      if (!response.data) {
        alerts.error('Error occurred while syncing the Asset Type with Endpoint Management.');
      } else {
        alerts.success('The Asset Type successfully synced with Endpoint Management.');
        $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
        _closeConfirmSyncWithNetComplyDialog();
      }
      loaderService.showViewLoader = false;
    });
  }

  function _performSyncWithNetComply($event) {
    loaderService.showViewLoader = true;
    return assetDataService.synchronizeAssetTypesFromNetComply(vm.assetType.customerAssetTypeId).then(response => {
      if (!response.data) {
        alerts.error('Error occurred while syncing the Asset Type with Endpoint Management.');
      } else {
        alerts.success('The Asset Type successfully synced with Endpoint Management.');
        $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
        _closeConfirmSyncWithNetComplyDialog();
      }
      loaderService.showViewLoader = false;
    });
  }

  function _closeConfirmSyncWithNetComplyDialog() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.confirmSyncWithNetComplyDialog);
  }

  function _showSyncAssetTypeDialog($event) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.assetAdmin.syncAssetTypeDialog = ssDialogService.alert(
      syncAssetTypeDialog.getOptions($event, {
        assetType: vm.assetTypeOfSync,
      }),
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.syncAssetTypeDialog);
  }

  function _initCriticalityForAssets(assets) {
    if (assets && assets.length > 0) {
      R.forEach(item => {
        const classMappings = {
          1: 'status-tier-bar--terrible',
          2: 'status-tier-bar--bad',
          3: 'status-tier-bar--caution',
          4: 'status-tier-bar--good',
          5: 'status-tier-bar--great',
        };
        item.criticalityCssClass = classMappings[item.assetCriticalityId];
        item.assetCriticality = assetSharedModelService.AssetCriticalities.find(
          assetCriticality => assetCriticality.assetCriticalityId === item.assetCriticalityId,
        );
      }, assets);
    }
  }
}

AssetsByTypeController.$inject = [
  '$scope',
  '$q',
  '$rootScope',
  'alerts',
  'confirmDialog',
  'userService',
  'ssDialogService',
  'editAssetDialog',
  'loaderService',
  'assetSharedModelService',
  'assetDataService',
  'praDataService',
  'bulkDeleteAssetsDialog',
  'bulkChangeAssetTypesDialog',
  'syncAssetTypeDialog',
];

